<template>
  <div>
    <div class="centertankuang" v-show="showalert"><!-- 提交失败 -->
      <div class="alertsauccess">
        {{message}}
      </div>
    </div>
  <div class="box" v-show="isShow">
    <div class="center"><!-- 提交成功 -->
      <p class="text1">留言提交成功</p>
      <p class="text2">请耐心等待，我们会尽快联系您！<br/>并为您提供校区筹备期、启动期和运营期全套方案！</p>
      <p class="btn" @click="close()">确认</p>
    </div>
  </div>
  </div>
</template>

<script>
import Bus from '../config/bus';
import { setTimeout } from 'timers';
export default {
  data(){
    return{
      showalert:false,
      message:"",
      isShow:false
    }
  },
  mounted(){
    this.getShowFormalert()
  },
  methods:{
    getShowFormalert(){
      Bus.$on('showalert', (val,boolzhi) => {
        if(val==0){
          this.message="请输入完整信息"
          this.showalert=true
        }
        if(val==1){
          this.isShow=true
        }
        setTimeout(()=>{
          this.showalert=false
        },2000)
			})
    },
    close(){
      this.isShow=false
    }
  }
}
</script>

<style lang="scss" scoped>
.box{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.3);
  z-index: 9999999;
}
.alertsauccess{
  width: vp(280);
  height: vp(90);
  line-height: vp(90);
  background: #333333;
  opacity: 0.65;
  text-align: center;
  border-radius: vp(40);
  color: white;
  font-size: vp(22)
}
.centertankuang{
  width: vp(280);
  height: vp(90);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 99999;
}
.center{
  width: vp(692);
  height: vp(534);
  background: url("../assets/landMb/success.png");
  background-size: cover;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 99999;
  p{
    font-family: 'SHS-M';
    line-height: vp(32);
    text-align: center;
  }
  .text1{
    color: #333;
    font-size: vp(32);
    margin-top: vp(262);
  }
  .text2{
    color: #666;
    font-size: vp(16);
    margin-top: vp(26);
  }
  .btn{
    background-color: #E1251B;
    width: vp(242);
    height: vp(56);
    border-radius: vp(28);
    margin: auto;
    line-height: vp(56);
    color: #fff;
    margin-top: vp(30);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alertext.vue